import React from "react";
import { ThemeProvider, css } from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";

const WrapperBanner = css`
  box-shadow: -10px -10px 10px #ffffff, 1px 5px 20px 2px #00000080;

  .swiper-pagination-bullet {
    background: ${(props) => props.theme.color};
  }
`;

const colorTheme = {
  live22: {
    color: "#0396ff",
  },
  slotxo: {
    color: "#E40203",
  },
  pgslot: {
    color: "#28BC7B",
  },
  joker: {
    color: "#FF12A4",
  },
  ambslot: {
    color: "#FFB503",
  },
};

const BannerComponent = ({ bannerList, pageName }) => {
  return (
    <ThemeProvider theme={colorTheme[pageName]}>
      <div css={WrapperBanner} className="w-full mt-5">
        <Swiper
          slidesPerView={1}
          pagination={{
            clickable: true,
          }}
          loop={true}
          modules={[Autoplay, Pagination]}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          className="mySwiper"
        >
          {bannerList.map((items, index) => (
            <SwiperSlide key={index}>
              <img src={items.url} alt="" />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </ThemeProvider>
  );
};

export default BannerComponent;
